import React from "react";

/**
 * Cover photo that scales to the container without cropping or stretching.
 */
export default function FitCoverImage({
  src,
  alt = "",
  maxHeight = 360,
  radius = 12,
  marginBottom = 20,
}) {
  if (!src) return null;

  return (
    <div
      style={{
        width: "100%",
        maxHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        borderRadius: radius,
        marginBottom,
        background: "#e2e8f0",
      }}
    >
      <img
        src={src}
        alt={alt}
        style={{
          width: "100%",
          height: "auto",
          maxHeight,
          objectFit: "contain",
          objectPosition: "center",
          display: "block",
        }}
      />
    </div>
  );
}
